<template>
  <div style="max-height: 50vh;overflow-y: scroll">
    <el-row class="margin-bottom-10">
      <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24"
              style="line-height:40px;height:40px;margin-bottom:10px;background-color:#042340;text-align: center;">
        {{ form.name }}
      </el-col>
    </el-row>

    <el-button @touchstart="synchronize" @click="synchronize" class="float-right"
               size="mini" style="margin-bottom: 5px"
               type="primary">同步所有型号
    </el-button>

    <el-table v-if="listData.length > 0" :data="listData" :height="tableHeight" align="center"
              row-key="id" size="mini"
              style="width: 100%;">
      <el-table-column
        align="center"
        label="序号"
        prop="index"
        type="index"></el-table-column>
      <el-table-column align="center" label="测点名称" prop="name"></el-table-column>
      <el-table-column align="center" label="排序(顺序)" prop="sort">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.sort" :controls="false" :precision="0" size="mini"
                           @change="(currentVal,oldVal)=>onSortChange(currentVal,oldVal,scope.row)"/>
        </template>
      </el-table-column>
      <el-table-column align="center" label="告警描述" prop="alarmDesc">
        <template slot-scope="scope">
          <el-input :controls="false" @change="(currentVal,oldVal)=>onSortChange(currentVal,oldVal,scope.row)"
                    size="mini"
                    v-model="scope.row.alarmDesc"/>
        </template>
      </el-table-column>
      <el-table-column align="center" label="告警恢复描述" prop="alarmRestoreDesc">
        <template slot-scope="scope">
          <el-input :controls="false" @change="(currentVal,oldVal)=>onSortChange(currentVal,oldVal,scope.row)"
                    size="mini"
                    v-model="scope.row.alarmRestoreDesc"/>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;line-height: 30vh" v-else>暂无数据</div>
  </div>
</template>

<script>
import {listByModelIdAndDeviceId} from "@/network/device-model-control";
import {listByDeviceId, synchronousSorting, updateDeviceMeasuringPoint} from "@/network/device-measuring-point";

export default {
  name: "ShowList",
  props: {
    deviceInfo: {},
    dialogData: null,
  },
  computed: {
    tableHeight() {
      return window.innerHeight / 2 - 200
    }
  },
  data() {
    return {
      listData: [],
      form: {
        name: this.deviceInfo.name,
        note: this.deviceInfo.note
      }
    }
  },
  mounted() {
    this.listData = []
    this.getData();
  },
  methods: {
    getData() {
      if (this.dialogData === 'control') {
        this.getControlList();
      } else if (this.dialogData === 'point') {
        this.getPointList();
      }
    },
    getControlList() {
      listByModelIdAndDeviceId(this.deviceInfo.modelId, this.deviceInfo.id).then(res => {
        if (res.code === 0) {
          this.listData = res.data.modelControls
        }
      })
    },
    getPointList() {
      listByDeviceId(this.deviceInfo.id).then(res => {
        this.listData = res.data;
      })
    },
    onSortChange(currentVal, oldVal, row) {
      updateDeviceMeasuringPoint(row).then(res => {
        if (res.code === 0) {
          this.$message.success("修改成功")
          this.getData();
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //同步测点排序到相同型号
    synchronize() {
      synchronousSorting(this.deviceInfo.id).then(res => {
        if (res.code === 0) {
          this.$message.success("同步成功!")
        } else {
          this.$message.error("同步失败!")
        }
      })
    }
  },
}
</script>

<style scoped>

</style>
